<template>
	<div class="custom-input" @focusout="closeDatepicker"
	>
		<vx-input-group class="custom-input__row">
			<div class="custom-input__row">
				<datepicker
					v-if="type === 'date'"
					v-model="dateAccessor"
					v-validate="'required'"
					ref="datepicker"
					:disabled-dates="disabledDates"
					:format="format"
					:disabled="disabled"
					:placeholder="placeholder"
					:language="languages[locale]"
					name="date"
					class="custom-input__datepicker right-border-radius-none"
				></datepicker>
				<template v-else>
					<Datetime
						v-model="datetimePickerDate"
						ref="datetime"
						:key="datetimePickerDate"
						:type="type"
						:phrases="controlPhrases"
						:min-datetime="minDatetime"
						class="datetime theme-primary"
					/>
					<vs-input
						v-model="inputDate"
						@keydown.prevent
						@click.stop="openDatepicker"
						class="custom-input__datepicker right-border-radius-none"
					/>
				</template>

				<div class="custom-input__addon" @click="openDatepicker">
					<vs-custom-button :disabled="disabled" color="rgba(0, 0, 0, 0.2)" type="border" icon-pack="feather">
						<svg width="16" height="16" x="0" y="0" class="stencil--easier-to-select"
							 style="opacity: 1;">
							<defs></defs>
							<rect x="0" y="0" width="16" height="16" fill="transparent"
								  class="stencil__selection-helper"></rect>
							<path
								d="M5.333333333333334 7.200000000000001C5.333333333333334 7.200000000000001 3.555555555555555 7.200000000000001 3.555555555555555 7.200000000000001 3.555555555555555 7.200000000000001 3.555555555555555 8.8 3.555555555555555 8.8 3.555555555555555 8.8 5.333333333333334 8.8 5.333333333333334 8.8 5.333333333333334 8.8 5.333333333333334 7.200000000000001 5.333333333333334 7.200000000000001 5.333333333333334 7.200000000000001 5.333333333333334 7.200000000000001 5.333333333333334 7.200000000000001M8.88888888888889 7.200000000000001C8.88888888888889 7.200000000000001 7.111111111111111 7.200000000000001 7.111111111111111 7.200000000000001 7.111111111111111 7.200000000000001 7.111111111111111 8.8 7.111111111111111 8.8 7.111111111111111 8.8 8.88888888888889 8.8 8.88888888888889 8.8 8.88888888888889 8.8 8.88888888888889 7.200000000000001 8.88888888888889 7.200000000000001 8.88888888888889 7.200000000000001 8.88888888888889 7.200000000000001 8.88888888888889 7.200000000000001M12.444444444444445 7.200000000000001C12.444444444444445 7.200000000000001 10.666666666666666 7.200000000000001 10.666666666666666 7.200000000000001 10.666666666666666 7.200000000000001 10.666666666666666 8.8 10.666666666666666 8.8 10.666666666666666 8.8 12.444444444444445 8.8 12.444444444444445 8.8 12.444444444444445 8.8 12.444444444444445 7.200000000000001 12.444444444444445 7.200000000000001 12.444444444444445 7.200000000000001 12.444444444444445 7.200000000000001 12.444444444444445 7.200000000000001M14.222222222222223 1.6C14.222222222222223 1.6 13.333333333333334 1.6 13.333333333333334 1.6 13.333333333333334 1.6 13.333333333333334 0 13.333333333333334 0 13.333333333333334 0 11.555555555555555 0 11.555555555555555 0 11.555555555555555 0 11.555555555555555 1.6 11.555555555555555 1.6 11.555555555555555 1.6 4.444444444444445 1.6 4.444444444444445 1.6 4.444444444444445 1.6 4.444444444444445 0 4.444444444444445 0 4.444444444444445 0 2.6666666666666665 0 2.6666666666666665 0 2.6666666666666665 0 2.6666666666666665 1.6 2.6666666666666665 1.6 2.6666666666666665 1.6 1.7777777777777781 1.6 1.7777777777777781 1.6 0.7911111111111113 1.6 0.008888888888888502 2.3200000000000003 0.008888888888888502 3.2000000000000006 0.008888888888888502 3.2000000000000006 0 14.4 0 14.4 0 15.28365559972927 0.7959382225230343 16 1.7777777777777781 16 1.7777777777777781 16 14.222222222222223 16 14.222222222222223 16 15.200000000000001 16 15.999999999999998 15.280000000000003 15.999999999999998 14.4 15.999999999999998 14.4 15.999999999999998 3.2000000000000006 15.999999999999998 3.2000000000000006 15.999999999999998 2.3200000000000003 15.200000000000001 1.6 14.222222222222223 1.6 14.222222222222223 1.6 14.222222222222223 1.6 14.222222222222223 1.6M14.222222222222223 14.4C14.222222222222223 14.4 1.7777777777777781 14.4 1.7777777777777781 14.4 1.7777777777777781 14.4 1.7777777777777781 5.6 1.7777777777777781 5.6 1.7777777777777781 5.6 14.222222222222223 5.6 14.222222222222223 5.6 14.222222222222223 5.6 14.222222222222223 14.4 14.222222222222223 14.4 14.222222222222223 14.4 14.222222222222223 14.4 14.222222222222223 14.4"
								stroke-width="0" stroke="none" stroke-dasharray="none" fill="rgb(98, 98, 98)"
								fill-rule="evenOdd"></path>
						</svg>
					</vs-custom-button>
				</div>
			</div>
		</vx-input-group>
	</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {de, ru} from 'vuejs-datepicker/dist/locale'
import VxInputGroup from "@/components/vx-input-group/VxInputGroup";
import { Datetime } from "vue-datetime";
import { Settings } from 'luxon';
import moment from 'moment';

export default {
	name: "VsDatepicker",
	components: {
		VxInputGroup,
		Datepicker,
		Datetime
	},
	model: {
		prop: 'date',
		event: 'change'
	},
	props: {
		date: 			{ default: "" },
		to:				{ type: [Date, null], 	default: null },
		disabled: 		{ default: null },
		format: 		{ type: String, 		default: "dd.MM.yyyy" },
		placeholder: 	{ type: String, 		default: "" },
		type: 			{ type: String, 		default: "date" }
	},
	data() {
		return {
			languages: {
				de,
				ru
			},
		};
	},
	watch: {
		locale(value) {
			Settings.defaultLocale = value;
		}
	},
	computed: {
		disabledDates() {
			let to = this.formatDate(this.to);
			to.setDate(to.getDate() - 1);
			console.log(to)
			return { to }
		},
		minDatetime() {
			console.log(moment(this.formatDate(this.to)).format("YYYY-MM-DD"))
			return moment(this.formatDate(this.to)).format("YYYY-MM-DD")
		},
		locale() {
			return this.$store.state.locale;
		},
		controlPhrases() {
			return {
				ok: this.$t("confirm"),
				cancel: this.$t('cancel')
			};
		},
		dateAccessor: {
			get() {
				return this.date;
			},
			set(value) {
				this.$emit('change', value);
			}
		},
		inputDate() {
			return moment(this.dateAccessor).format('DD.MM.YYYY HH:mm');
		},
		datetimePickerDate: {
			get() {
				return moment(this.dateAccessor).format('YYYY-MM-DDTHH:mm:SS');
			},
			set(value) {
				if(value === "") return;

				const date = new Date(value);
				this.dateAccessor = date;
			}
		}
	},
	methods: {
		displayLog(log) {
			console.log(log)
		},
		formatDate(date) {
			return new Date(new Date(date).setHours(20))
		},
		openDatepicker() {
			if(this.type === "date") {
				this.$refs.datepicker.$el
					.children[0]
					.children[0]
					.click();
			} else {
				this.$refs.datetime.$el
					.children[0]
					.click();
			}
		},
		closeDatepicker() {
			if(this.$refs.datepicker) {
				this.$refs.datepicker.close()
			}
		}
	},
	mounted() {
		Settings.defaultLocale = this.locale;
	}
}
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables.scss";

.custom-input {
	&__row {
		display: flex;
	}

	&__datepicker {
		flex: 100px 1 1;
		width: 100%;
	}

	&__addon {
		flex: 20px 0 0;

		.vs-button {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 37px;
			height: 100%;
			padding: 0 !important;
			border-left: none;
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
		}

		.stencil--easier-to-select {
			display: flex;
			align-items: center;
			margin-bottom: 1px;
		}
	}

	.datetime {
		.vdatetime-popup {
			border-radius: 8px;

			&__header {
				border-top-left-radius: 8px;
				border-top-right-radius: 8px;
			}
		}

		.vdatetime-input {
			width: 0;
			height: 0;
			margin: 0;
			padding: 0;
			border: 0;
			outline: 0;
		}
	}

	.theme-primary .vdatetime-popup__header,
	.theme-primary .vdatetime-calendar__month__day--selected > span > span,
	.theme-primary .vdatetime-calendar__month__day--selected:hover > span > span {
		background: $primary;
	}

	.theme-primary .vdatetime-year-picker__item--selected,
	.theme-primary .vdatetime-time-picker__item--selected,
	.theme-primary .vdatetime-popup__actions__button {
		color: $primary;
	}
}

</style>
